<template>
  <div id="header">
    <v-container text-xs-center>
      <img src="../assets/logo.png" class=" mt-5 pt-5 pb-4" />
      <v-layout row wrap justify-center>
        <v-flex xs10>
          <hr class="header-line" />
          <v-card class="h-card py-4" flat>
            <h1 text-sm-center mb-0 class="dc-heading">
              -Homicidios de personas LGBT+ en México-
            </h1>
            <p text-sm-center mb-0 class="dc-text">
              Filtra por orientación sexual e identidad de género de la víctima
              y geografía, y descarga la información agregada.
            </p>
          </v-card>
          <hr class="header-line mb-4" />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {}
};
</script>

<style lang="scss">
#header {
  background-color: #f7f7f7;
  font-family: "Roboto Slab", serif;
  background-image: url("../assets/person.png");
  background-position: center;
}
#header .h-card {
  background-color: transparent;
}
.dc-heading {
  color: #be3117;
  font-size: 32px;
  font-weight: 900;
}

.dc-text {
  font-size: 20px;
  font-weight: 500;
}
.header-line {
  height: 5px;
  background: black;
}
</style>
